import { jsx as _jsx } from "react/jsx-runtime";
import { newFeaturePopperOptions } from 'common/const/system-config/new-feature-popper-options.const';
import { useSelector } from 'react-redux';
import NewFeaturePopper from './NewFeaturePopper';
var RootNewFeaturePopper = function () {
    var _a = useSelector(function (_a) {
        var base = _a.base;
        return base.newFeaturePopperReducer.newFeaturePopper;
    }), anchorEl = _a.anchorEl, newFeatureId = _a.newFeatureId;
    var newFeaturePopperOptionsById = newFeatureId !== '' ? newFeaturePopperOptions[newFeatureId] : undefined;
    return !!newFeaturePopperOptionsById && !!anchorEl ? (_jsx(NewFeaturePopper, { newFeatureId: newFeatureId, activeUntilDateStr: newFeaturePopperOptionsById.activeUntilDateStr, placement: newFeaturePopperOptionsById.placement, anchorEl: anchorEl, text: newFeaturePopperOptionsById.text, buttonText: newFeaturePopperOptionsById.buttonText }, void 0)) : null;
};
export default RootNewFeaturePopper;
